module.exports = __webpack_public_path__ + "mobile/img/icon_mine_logo1_8.f7a78b4f.png";